var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto",staticStyle:{"padding":"16px"},attrs:{"max-height":"400","outlined":""}},[_c('v-card-title',[_vm._v(" Bokningsstatistik ")]),_c('bar-chart',{attrs:{"styles":_vm.myStyles,"orders":_vm.orders}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }